import Sidebar from './Sidebar';
import { SidebarLinkItemProps, SidebarHierarchyItemProps, SidebarSeparatorItemProps } from './SidebarItem';

export type SidebarItemType = SidebarLinkItemProps |
  SidebarHierarchyItemProps | SidebarSeparatorItemProps;

export default Sidebar;
